module.exports = __webpack_public_path__ + "img/stop-diversion-cost.e95384a7.svg";